import Field from './Field';
import { getImageResource } from '../../../../services/resources';

export default class Image extends Field {

    constructor() {
        super();
        this.type = 'Image';
        this.maxSize = [32, 52];
        this.minSize = [1, 1];
        this.imageData = null;
    }
    
    create(target, options) {
        let container = document.createElement('div');
        let image = document.createElement('img');

        if (this.props.macro) {
            image.classList.add('has-macro');
            image.addEventListener('click', (e) => {
                let mods = '';
                if (e.ctrlKey) {
                    mods = 'ctrl';
                }
                return this.runMacro(mods);
            });
        }

        container.classList.add('sheet-container');
        image.classList.add('sheet-image');

        this.elements = {container, image};
        this.update(options);

        container.append(image);
        target.append(container);
    }

    update(options) {
        (async () => {
            if (this.props.resourceId) {
                let imageData = await getImageResource(this.props.resourceId);
                this.elements.image.src = imageData;
            }
        })();

        this.elements.container.style.fontSize = `${options.unit}px`;
        this.elements.container.style.backgroundColor = options.highlight ? '#444' : 'transparent';
        this.elements.container.style.gridRowStart = 1 + this.y;
        this.elements.container.style.gridColumnStart = 1 + this.x;
        this.elements.container.style.gridRowEnd = (1 + this.y) + (this.height);
        this.elements.container.style.gridColumnEnd = (1 + this.x) + (this.width);

        this.elements.container.classList[options.selectedId === this.id ? 'add' : 'remove']('selected');
    }

    set() {}

    get() {return '';}

    clean() {}

    error() {}

    fix() {}

}